import { render, staticRenderFns } from "./ListaRelatorio.vue?vue&type=template&id=bbc1335c&scoped=true&"
import script from "./ListaRelatorio.vue?vue&type=script&lang=js&"
export * from "./ListaRelatorio.vue?vue&type=script&lang=js&"
import style0 from "./ListaRelatorio.vue?vue&type=style&index=0&id=bbc1335c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc1335c",
  null
  
)

export default component.exports